import React from 'react';

const ACCIONES = {
  banear: {
    titulo: 'Confirmar baneo',
    descripcion: (duracion) => duracion
      ? `¿Aplicar timeout de ${duracion} día${duracion > 1 ? 's' : ''} a este usuario?`
      : '¿Banear permanentemente a este usuario?',
    confirmClass: 'bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-800',
    confirmLabel: 'Banear',
  },
  desbanear: {
    titulo: 'Confirmar desbaneo',
    descripcion: () => '¿Levantar el baneo/timeout de este usuario?',
    confirmClass: 'bg-emerald-600 hover:bg-emerald-700',
    confirmLabel: 'Desbanear',
  },
  actualizarRol: {
    titulo: 'Confirmar cambio de rol',
    descripcion: (_, nuevoRol) => `¿Cambiar el rol a "${nuevoRol}"?`,
    confirmClass: 'bg-blue-600 hover:bg-blue-700',
    confirmLabel: 'Confirmar',
  },
};

const ConfirmationDialog = ({
  showConfirmDialog,
  handleCancelarAccion,
  ejecutarAccion,
  accionPendiente,
}) => {
  if (!showConfirmDialog) return null;

  const tipo = accionPendiente?.accion || 'banear';
  const cfg = ACCIONES[tipo] || ACCIONES.banear;
  const descripcion = cfg.descripcion(accionPendiente?.duracion, accionPendiente?.nuevoRol);

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-3 sm:p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl p-5 max-w-sm w-full shadow-2xl">
        <h4 className="text-base font-semibold mb-2 dark:text-white">{cfg.titulo}</h4>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-5">{descripcion}</p>
        <div className="flex justify-end gap-2">
          <button
            onClick={handleCancelarAccion}
            className="px-4 py-2 text-sm bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={ejecutarAccion}
            className={`px-4 py-2 text-sm text-white rounded-lg transition-colors ${cfg.confirmClass}`}
          >
            {cfg.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
